import vv_utils from './vv_utils';
import { fullInvokeMachine, simpleInvokeMachine } from "./vv_api";
import validateEmail from './email-validator';

/*-----------------------------------------------
|   Forgot Password
-----------------------------------------------*/

const forgotPasswordInit = () => {

  const fieldFormMap = {
    "email": "#email",
  }

  const alertbox = document.getElementById("split-alert");

  if (window.vv_tenant_data && window.vv_tenant_data.support_url) {
    document.getElementById("supportLink").href = window.vv_tenant_data.support_url;
  } else {
    document.getElementById("supportLink").classList.add("d-none");
  }

  function checkValidity() {
    return  new Promise((resolve, reject)=>{
      let valid = true;
      let email = document.getElementById('email');
      
      if(email.value && validateEmail(email.value) && email.value.length <= 320){
        //do nothing bootstrap handles the clearing
      } else {
        
        vv_utils.makeInvalid(email);
        valid = false;
      }

      if(valid){
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }     
    })
  }

  function formSubmit(e) {
    if (e.preventDefault) e.preventDefault();
  }

  const forgotPassword = async (userstate) => {
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/auth/password/forgot`, userstate, 'POST',vv_utils.defaultTimeout);
  }

  function doForgotPassword(servError, service) {
    let email = document.getElementById('email').value;

    let userstate = { 'email': email };
    return forgotPassword(userstate);
  }

  const { interpret } = window.XState;
 
  const form = document.getElementById("forgotPasswordForm");
 
  const validationService = interpret(
    fullInvokeMachine.withConfig({
      actions: {
        loaded: () => {
          
        },
        message: (context, event) => {
          vv_utils.clearInputValidation(form);
          vv_utils.clearalert(alertbox);
        },
        validationFailed: () => {
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", alertbox);
        },
        validationSucceeded: () => {
          validationService.send("PERFORM_ACTION");
        },
        actionFailed: (context, event) => {
          
          if(context.error.fields){
            const invalidIds = context.error.fields.map((field) => fieldFormMap[field]);
            invalidIds.forEach((id)=>{
              vv_utils.makeInvalid(id);
            })
          }
          vv_utils.logError(context.error);
          vv_utils.showStateErrors("There was an unexpected error", context.error , alertbox);
        },
        actionSucceeded: (context, event) => {
          vv_utils.showalert("An email has been sent to you, please enter the 6 digit code from that email below.", "primary", alertbox);
          validationService.send("LOAD_COMPLETE");
          document.getElementById("forgotBlock").classList.add("d-none");
          document.getElementById("verifyTitle").innerText = "Please check your inbox for the verification code";
          document.getElementById("verifyBlock").classList.remove("d-none");
        }
      },
      services: {
        validate_service: (context, event) => checkValidity(context, event),
        action_service: (context, event) => {return doForgotPassword(context, event)}
      }
    })
  )
  .onTransition((state) => {})
  .start();
  
  //eslint-disable-next-line
  vv_utils.addFormAndMachineServiceChangeAndInputHandlers(form, validationService, formSubmit);
  
  vv_utils.AttachAndSendFormEventsToMachineService(form, validationService, 'input', 'input');

  //After the state machince is fully configured, move out of loading
  validationService.send("LOAD_COMPLETE");


////Resend

  const resendService = interpret(

    simpleInvokeMachine.withConfig({
      actions : {
        actionFailed: (context, event) => {
          
          if(context.error.fields){
            const invalidIds = context.error.fields.map((field) => fieldFormMap[field]);
            invalidIds.forEach((id)=>{
              vv_utils.makeInvalid(id);
            })
          }
          vv_utils.logError(context.error);
          vv_utils.showStateErrors("There was an unexpected error", context.error , alertbox);
        },
        actionSucceeded: (context, event)=> {
          
          document.getElementById("verifyTitle").innerText = "Please check your inbox for the verification code";
          vv_utils.showalert("An email has been re-sent to you, please enter the 6 digit code from that email below.", "primary", alertbox);
          resendService.send("IDLE");
        }
      },
      services: {
        //eslint-disable-next-line
        action_service: (context, event) =>  {return doForgotPassword(context, event)}
      }
    })
  )
  .onTransition((state)=> {})
  .start();

  document.getElementById("vvModalVerifyCodeResendBtn").addEventListener('click', (e) => {
    e.preventDefault();
    document.getElementById("verifyTitle").innerText = "Re-sending now...";
    resendService.send("FETCH");
  })

////////////////////////////////////////////////


  //Modal VerificationCode Update
  const vvModalVerifyCodeForm = document.getElementById("vvModalVerifyCodeForm");
  const vvModalVerifyCodeFeedback = document.getElementById('vvModalVerifyCodeFeedback');
  const vvModalVerifyCodeUpdateSaveBtn = document.getElementById('vvModalVerifyCodeUpdateSaveBtn');

  const verificationcodeFieldFormMap = {
    'code': '#verificationcode',
    'password': "#split-password"
  }
  
  //This had to be done manually instead of using bootstrap because we
  //added a custom 'eye' icon through a container div that did not allow for a 
  //feedback div directly under the input tag like normal
  function clearPasswordFeedback() {
    let passwordfeedback = document.getElementById('split-password-feedback');

    passwordfeedback.style.display = 'none';

    let password = document.getElementById('split-password');
    password.classList.remove(':valid');
    password.classList.remove(':invalid');

  }

  function checkVerificationCodeValidity() {
    return new Promise((resolve, reject) => {
      
      let vvModalVerifyCodeText = document.getElementById("verificationcode");
      let valid = true;

      //should be a 6 digit string
      //eslint-disable-next-line
      vvModalVerifyCodeText.value = vvModalVerifyCodeText.value.replace(/[^\d]+/g, '');
      if (vvModalVerifyCodeText.value && vvModalVerifyCodeText.value.length === 6 && /^\d+$/.test(vvModalVerifyCodeText.value)) {
        //
      } else {
        valid = false;
        vv_utils.makeInvalid(vvModalVerifyCodeText);
      }

      let password = document.getElementById('split-password');
      let passwordfeedback = document.getElementById('split-password-feedback');
      let confirmPassword = document.getElementById('split-confirm-password');
      let confirmPasswordFeedback = document.getElementById('split-confirm-password-feedback');

      // eslint-disable-next-line
      if (password.value && (password.value.length >= 10) && (password.value.length <= 255)) {
        clearPasswordFeedback();
      } else {
          vv_utils.makeInvalid(password);
          passwordfeedback.style.display = 'block';
          
          valid = false;
      }
          


      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function updateVerificationCode(context, event) {
    
    //in the future pass the verificationcode value through state machine 
    let verificationcode = document.getElementById('verificationcode').value;
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/auth/password/reset`, 
      { 
        "code": verificationcode,
        "email": document.getElementById('email').value,
        "password": document.getElementById('split-password').value,
        "send": false,
      }, "POST");
  }

  const updateVerificationCodeMachine = interpret(
    fullInvokeMachine.withConfig({
      actions: {
        loaded: () => {
          
        },
        message: (context, event) => {
          //
          vv_utils.clearInputValidation(vvModalVerifyCodeForm);
          vv_utils.clearalert(alertbox);
          clearPasswordFeedback();
        },
        validationFailed: () => {
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", alertbox);
        },
        validationSucceeded: () => {
          updateVerificationCodeMachine.send("PERFORM_ACTION");
        },
        actionFailed: (context, event) => {          
          if (context.error && context.error.fields) {
            vv_utils.highlightFields(context.error.fields, verificationcodeFieldFormMap);
          }
          vv_utils.logError(context.error);
          vv_utils.showStateErrors("There was an unexpected error", context.error, alertbox);
        },
        actionSucceeded: (context, event) => {
          updateVerificationCodeMachine.send("LOAD_COMPLETE");
          vv_utils.clearalert(alertbox);
          clearPasswordFeedback();          
          if (context.data.redirect) {
            window.location.assign(context.data.redirect);
            return;
          }
          if (context.data.mfa_required) {
            const codeBlock = document.getElementById("verifyBlock");
            codeBlock.classList.add("d-none");
            document.getElementById("verifyMFABlock").classList.remove("d-none");
          } else {
            vv_utils.showalert("Password reset succeeded, now redirecting you to our login page.", "primary", alertbox);
            setTimeout( () => {window.location.assign("/login")} , 3000);            
          }

        }
      },
      services: {
        //eslint-disable-next-line
        validate_service: (context, event) => checkVerificationCodeValidity(context, event),
        action_service: (context, event) => updateVerificationCode(context, event)
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  //eslint-disable-next-line
  vv_utils.AttachAndSendFormEventsToMachineService(vvModalVerifyCodeForm, updateVerificationCodeMachine, 'input', 'input');
  //eslint-disable-next-line
  vv_utils.addFormAndMachineServiceChangeAndInputHandlers(vvModalVerifyCodeForm, updateVerificationCodeMachine, formSubmit);

  updateVerificationCodeMachine.send("LOAD_COMPLETE");

  vvModalVerifyCodeUpdateSaveBtn.addEventListener('click', (e) => {
    e.preventDefault();
    updateVerificationCodeMachine.send("SUBMIT");
  })

////////////////////////////////////////////////


  //MFA VerificationMFACode Update
  const vvModalVerifyMFACodeForm = document.getElementById("vvModalVerifyMFACodeForm");
  const vvModalVerifyMFACodeFeedback = document.getElementById('vvModalVerifyMFACodeFeedback');
  const vvModalVerifyMFACodeUpdateSaveBtn = document.getElementById('vvModalVerifyMFACodeUpdateSaveBtn');

  const verificationMFAcodeFieldFormMap = {
    'mfa_code': '#mfaverificationcode'
  }
  


  function checkVerificationMFACodeValidity() {
    return new Promise((resolve, reject) => {
      let vvModalVerifyCodeText = document.getElementById("mfaverificationcode");
      let valid = true;

      //should be a 6 digit string
      //eslint-disable-next-line
      vvModalVerifyCodeText.value = vvModalVerifyCodeText.value.replace(/[^\d]+/g, '');
      if (vvModalVerifyCodeText.value && vvModalVerifyCodeText.value.length === 6 && /^\d+$/.test(vvModalVerifyCodeText.value)) {
        //
      } else {
        valid = false;
        vv_utils.makeInvalid(vvModalVerifyCodeText);
      }

      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function updateVerificationMFACode(context, event) {
    
    //in the future pass the mfaverificationcode value through state machine 
    let mfaverificationcode = document.getElementById('mfaverificationcode').value;
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/auth/password/reset`, 
      { 
        "code":  document.getElementById('verificationcode').value,
        "mfa_code": mfaverificationcode,
        "email": document.getElementById('email').value,
        "password": document.getElementById('split-password').value,
        "send": false,
      }, "POST");
  }

  const updateVerificationMFACodeMachine = interpret(
    fullInvokeMachine.withConfig({
      actions: {
        loaded: () => {
          
        },
        message: (context, event) => {
          //
          vv_utils.clearInputValidation(vvModalVerifyMFACodeForm);
          vv_utils.clearalert(alertbox);
        },
        validationFailed: () => {
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", alertbox);
        },
        validationSucceeded: () => {
          updateVerificationMFACodeMachine.send("PERFORM_ACTION");
        },
        actionFailed: (context, event) => {
          
          

          if (context.error && context.error.fields) {          
            vv_utils.highlightFields(context.error.fields, verificationMFAcodeFieldFormMap);
          }

          
          if (context.error) {
            vv_utils.logError(context.error);
            
            vv_utils.showStateErrors("There was an unexpected error", context.error, alertbox);
          }
        },
        actionSucceeded: (context, event) => {
          
          updateVerificationMFACodeMachine.send("LOAD_COMPLETE");
          if (context.data.redirect) {
            window.location.assign(context.data.redirect);
            return;
          }
          vv_utils.showalert("Password reset succeeded, now redirecting you to our login page.", "primary", alertbox);
          setTimeout( () => {window.location.assign("/login")} , 3000);
        }
      },
      services: {
        //eslint-disable-next-line
        validate_service: (context, event) => checkVerificationMFACodeValidity(context, event),
        action_service: (context, event) => updateVerificationMFACode(context, event)
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  //eslint-disable-next-line
  vv_utils.AttachAndSendFormEventsToMachineService(vvModalVerifyMFACodeForm, updateVerificationMFACodeMachine, 'input', 'input');
  //eslint-disable-next-line
  vv_utils.addFormAndMachineServiceChangeAndInputHandlers(vvModalVerifyMFACodeForm, updateVerificationMFACodeMachine, formSubmit);

  updateVerificationMFACodeMachine.send("LOAD_COMPLETE");

  vvModalVerifyMFACodeUpdateSaveBtn.addEventListener('click', (e) => {
    e.preventDefault();
    updateVerificationMFACodeMachine.send("SUBMIT");
  })





//temp onload

}

export default {forgotPasswordInit};
